<template>
    <div class="slm-history-map__load-more">
        <button class="slm-load-more" @click="loadMore()">Visa fler ({{ postsLeft }} st)</button>
    </div>
</template>

<script>
export default {
    name: 'load-more-component',
    computed: {
        page() {
            return this.$store.state.page;
        },
        total() {
            return this.$store.state.filteredHistories.length;
        },
        postsLeft() {
            return this.$store.getters.postsLeft;
        }
    },
    methods: {
        loadMore() {
            this.$store.commit('setPage', this.page + 1);
            this.$store.commit('setFilteredHistories');
            this.$store.dispatch('setUrl');
        }
    }
}
</script>